/**
 * Link to a Git repo.
 */

// @todo: Migrate to 'Dialog.Alert' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Alert} from '@wandb/weave/components/Alert';
// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {IconOpenNewTab} from '@wandb/weave/components/Icon';
import React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

import {GitHubReference} from '../github';
import {TargetBlank} from '../Link';

type LinkGitProps = {
  git: {
    remote: string;
    commit: string;
  };
  children: React.ReactNode;
};

const CenteredFlex = styled.span`
  display: inline-flex;
  align-items: center;
`;
CenteredFlex.displayName = 'S.CenteredFlex';

export const LinkGit = ({git, children}: LinkGitProps) => {
  const ref = GitHubReference.parse(git.remote);
  if (ref == null) {
    return (
      <Alert severity="warning">Unable to parse git remote: {git.remote}</Alert>
    );
  }
  const url = ref ? ref.url_repo() : git.remote;
  const href = url + `/tree/${git.commit}`;
  return (
    <TargetBlank href={href}>
      <CenteredFlex>
        {children}
        <IconOpenNewTab />
      </CenteredFlex>
    </TargetBlank>
  );
};
